import { useState, ReactNode, FC } from 'react';

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const Tooltip: FC<TooltipProps> = ({
  content,
  children,
  position = 'top',
  className = '',
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  const hasContent = Boolean(
    content !== undefined && content !== null && content !== ''
  );

  return (
    <div
      className={`relative inline-flex items-center ${className}`}
      onMouseEnter={() => hasContent && setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => hasContent && setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      {children}
      {isVisible && hasContent && (
        <div
          role="tooltip"
          className={`z-60 animate-in fade-in zoom-in-95 pointer-events-none absolute max-w-xs whitespace-normal break-words rounded-lg border border-slate-700 bg-slate-900 px-2.5 py-1.5 text-micro font-medium text-slate-100 shadow-2xl transition-opacity duration-150 dark:bg-slate-800 ${positionClasses[position]}`}
        >
          {content}
        </div>
      )}
    </div>
  );
};
